import React from 'react';
import { Input as TdsInput, FormItem as TdsFormItem } from '@tesla/react-tds/global';
import useFormField from '../../hooks/useFormField';
import withFormatted from '../withFormatted';

const Input = withFormatted(TdsInput);

export default function FormattedInput({ label, ...props }) {
  const { formFieldContext, render, userProps, formFieldRef, defaultHandler } = useFormField(props);

  return render(
    <TdsFormItem
      id={defaultHandler.id}
      label={label}
      error={formFieldContext.$showError}
      errorLabel={formFieldContext.error}
    >
      <Input {...defaultHandler} {...userProps} ref={formFieldRef} />
    </TdsFormItem>
  );
}

Input.propTypes = {};
